<template>
  <div class="m-2">
    <b-form-checkbox 
      v-model="all"
      :indeterminate="hasTrue && hasFalse"
      @change="emitEventAll()"
    >Alle</b-form-checkbox>
    <hr>
    <div v-for="(def, index) in detailColumnDefs" v-bind:key="index">
      <b-form-checkbox 
        v-model="def.hide" 
        :disabled="def.lockVisible"
        :value="false"
        :unchecked-value="true"
        @change="emitEvent(def.field, !def.hide)"
      >{{ def.headerName }}</b-form-checkbox>
    </div>
  </div>
</template>

<script>
import VwTapService from "../../services/VwTapService";
import EventBus from '@/services/EventBus.js'

export default {
  name: "DetailColumnToolPanel",
  data() {
    return {
      all: true,
      detailColumnDefs: null,
      hasTrue: null,
      hasFalse: null,
    }
  },
  created() {
    this.getGridColumnDefinitions();
  },
  mounted() {
    EventBus.$on('LoadDetailColumnToolPanelLocalization', () => {
      this.loadLocalization();
    })
  },
  methods: {
    async getGridColumnDefinitions() {
      return VwTapService.getGridColumnDefinitions(2)
      .then(response => {
        response.data.forEach(colDef => {
          colDef.headerName = this.$t(colDef.mdsEntry);
        });
        this.detailColumnDefs = response.data;
      })
    },
    emitEvent(field, hide) {
      EventBus.$emit('DetailColumnHide', field, hide);
    },
    emitEventAll() {
      this.detailColumnDefs.forEach(e => {
        if(this.all === true) {
          e.hide = true;
        } else {
          e.hide = false;
        }
        EventBus.$emit('DetailColumnHideAll', this.all);
      })
    },
    loadLocalization() {
      this.detailColumnDefs.forEach(colDef => {
        colDef.headerName = this.$t(colDef.mdsEntry);
      });
    }
  },
  watch: {
    detailColumnDefs: {
      handler() {
        this.hasTrue = false;
        this.hasFalse = false;
        this.detailColumnDefs.forEach(e => {
          if(e.hide === false) { this.hasTrue = true; }
          else if(e.hide === true) { this.hasFalse = true; }
        });
        if(this.hasTrue && this.hasFalse) { 
          this.all = false;
        } else if(!this.hasTrue && this.hasFalse) {
          this.all = false;
        } else if(this.hasTrue && !this.hasFalse) {
          this.all = true;
        }
      },
      deep: true
    },
  },
}
</script>

<style scoped>

</style>